// German translations
export const de: Record<string, string> = {
  // ==================== COMMON ====================
  'common.loading': 'Laden...',
  'common.error': 'Ein Fehler ist aufgetreten',
  'common.retry': 'Erneut versuchen',
  'common.cancel': 'Abbrechen',
  'common.save': 'Speichern',
  'common.continue': 'Fortfahren',
  'common.back': 'Zurück',
  'common.next': 'Weiter',
  'common.skip': 'Überspringen',
  'common.done': 'Fertig',
  'common.yes': 'Ja',
  'common.no': 'Nein',
  'common.ok': 'OK',
  'common.check': 'Prüfen',
  'common.correct': 'Richtig!',
  'common.incorrect': 'Falsch',
  'common.tryAgain': 'Erneut versuchen',
  'common.start': 'Starten',
  'common.finish': 'Beenden',
  'common.submit': 'Absenden',

  // ==================== NAVIGATION ====================
  'nav.home': 'Startseite',
  'nav.courses': 'Kurse',
  'nav.vocabulary': 'Vokabeln',
  'nav.profile': 'Profil',
  'nav.settings': 'Einstellungen',
  'nav.logout': 'Abmelden',
  'nav.leaderboard': 'Rangliste',
  'nav.aiTutor': 'KI-Tutor',

  // ==================== ONBOARDING ====================
  'onboarding.welcome': 'Willkommen bei KoreanFlow!',
  'onboarding.selectLanguage': 'Wähle deine Sprache',
  'onboarding.selectLanguageDesc': 'Wähle die Sprache für die App-Oberfläche',
  'onboarding.selectGoal': 'Was ist dein Lernziel?',
  'onboarding.selectGoalDesc': 'Wir personalisieren deinen Lernpfad',
  'onboarding.takeTest': 'Einstufungstest machen',
  'onboarding.takeTestDesc': 'Finde dein Koreanisch-Niveau in 5 Minuten heraus',
  'onboarding.skipTest': 'Vorerst überspringen',
  'onboarding.skipTestDesc': 'Von Anfang an beginnen',
  'onboarding.letsGo': 'Los geht\'s!',
  'onboarding.step': 'Schritt',
  'onboarding.of': 'von',

  // ==================== LEVEL TEST ====================
  'levelTest.title': 'Einstufungstest',
  'levelTest.subtitle': 'Lass uns dein Koreanisch-Niveau herausfinden',
  'levelTest.duration': 'Etwa 5 Minuten',
  'levelTest.questions': 'Fragen',
  'levelTest.vocabulary': 'Vokabeln',
  'levelTest.grammar': 'Grammatik',
  'levelTest.listening': 'Hörverstehen',
  'levelTest.speaking': 'Sprechen',
  'levelTest.analyzing': 'Analyse deiner Ergebnisse...',
  'levelTest.yourLevel': 'Dein Niveau',
  'levelTest.congratulations': 'Herzlichen Glückwunsch!',
  'levelTest.resultDesc': 'Basierend auf deinen Testergebnissen',
  'levelTest.startLearning': 'Mit dem Lernen beginnen',
  'levelTest.retakeTest': 'Test wiederholen',
  'levelTest.sectionComplete': 'Abschnitt abgeschlossen',
  'levelTest.nextSection': 'Nächster Abschnitt',
  'levelTest.listenAndAnswer': 'Höre zu und antworte',
  'levelTest.speakNow': 'Jetzt sprechen',
  'levelTest.tapToListen': 'Tippen zum Anhören',

  // ==================== CEFR LEVELS ====================
  'cefr.A1': 'Anfänger',
  'cefr.A2': 'Grundkenntnisse',
  'cefr.B1': 'Mittelstufe',
  'cefr.B2': 'Obere Mittelstufe',
  'cefr.C1': 'Fortgeschritten',
  'cefr.C2': 'Kompetente Sprachverwendung',
  'cefr.A1.desc': 'Grundlegende Begrüßungen und einfache Ausdrücke',
  'cefr.A2.desc': 'Einfache Gespräche über den Alltag',
  'cefr.B1.desc': 'Kann die meisten Reisesituationen bewältigen',
  'cefr.B2.desc': 'Kann fließend mit Muttersprachlern kommunizieren',
  'cefr.C1.desc': 'Kann Ideen fließend und spontan ausdrücken',
  'cefr.C2.desc': 'Nahezu muttersprachliche Kompetenz in allen Situationen',

  // ==================== LEAGUE / RANKING ====================
  'league.title': 'Liga',
  'league.weeklyRanking': 'Wöchentliche Rangliste',
  'league.bronze': 'Bronze',
  'league.silver': 'Silber',
  'league.gold': 'Gold',
  'league.platinum': 'Platin',
  'league.diamond': 'Diamant',
  'league.promotion': 'Aufstiegszone',
  'league.demotion': 'Abstiegszone',
  'league.safe': 'Sichere Zone',
  'league.weeklyXP': 'Wöchentliche XP',
  'league.rank': 'Rang',
  'league.daysLeft': 'Tage übrig',
  'league.promoted': 'Aufgestiegen!',
  'league.demoted': 'Abgestiegen',
  'league.stayed': 'Geblieben',
  'league.noData': 'Noch keine Ranglisten-Daten',
  'league.earnXP': 'Verdiene XP, um der Liga beizutreten!',
  'league.topPercent': 'Top {percent}%',

  // ==================== LANDING PAGE ====================
  'landing.tagline': 'Die Nr. 1 App zum Koreanisch lernen',
  'landing.title': 'Lerne Koreanisch',
  'landing.titleAccent': 'auf die spaßige Art',
  'landing.subtitle': 'Meistere Koreanisch mit kurzen Lektionen, K-Pop & K-Drama Inhalten und KI-gestütztem Aussprache-Feedback. Schließe dich 1M+ Lernenden an!',
  'landing.getStarted': 'Kostenlos starten',
  'landing.learnMore': 'Mehr erfahren',
  'landing.login': 'Anmelden',
  'landing.startFree': 'Kostenlos starten',
  'landing.learners': 'Lernende',
  'landing.lessons': 'Lektionen',
  'landing.countries': 'Länder',

  // ==================== FEATURES ====================
  'features.title': 'Warum KoreanFlow?',
  'features.subtitle': 'Unser einzigartiger Ansatz kombiniert Gamification, authentische Inhalte und KI-Technologie, um das Koreanisch-Lernen unterhaltsam und effektiv zu gestalten.',
  'features.streaks.title': 'Tägliche Serien',
  'features.streaks.desc': 'Baue eine Gewohnheit auf mit täglichen Zielen und Serien-Belohnungen. Bleibe motiviert mit XP und Edelsteinen.',
  'features.folksong.title': 'Volkslieder',
  'features.folksong.desc': 'Lerne Koreanisch durch traditionelle Volkslieder. Verstehe die Texte und Kultur!',
  'features.culture.title': 'Koreanische Kultur',
  'features.culture.desc': 'Entdecke Sprichwörter, Slang und wichtige Redewendungen. Meistere authentische Ausdrücke.',
  'features.ai.title': 'KI-Chatbot',
  'features.ai.desc': 'Übe Gespräche mit unserem KI-Tutor. Erhalte sofortiges Feedback und Korrekturen.',
  'features.leaderboard.title': 'Ranglisten',
  'features.leaderboard.desc': 'Tritt gegen Freunde und Lernende weltweit an. Klettere in den wöchentlichen Rankings!',
  'features.srs.title': 'SRS-Vokabeln',
  'features.srs.desc': 'Das intelligente Wiederholungssystem stellt sicher, dass du das Gelernte behältst. Für immer.',
  'features.pronunciation.title': 'Aussprache-Feedback',
  'features.pronunciation.desc': 'KI-gestützte Ausspracheanalyse mit detaillierter Bewertung.',

  // ==================== CTA ====================
  'cta.title': 'Bereit, deine Reise zu beginnen?',
  'cta.subtitle': 'Schließe dich Millionen von Lernenden an und beginne heute Koreanisch zu sprechen. Es ist kostenlos!',
  'cta.button': 'Kostenlos lernen starten',

  // ==================== AUTH ====================
  'auth.login': 'Anmelden',
  'auth.register': 'Registrieren',
  'auth.email': 'E-Mail',
  'auth.emailPlaceholder': 'Gib deine E-Mail ein',
  'auth.password': 'Passwort',
  'auth.passwordPlaceholder': 'Erstelle ein Passwort',
  'auth.confirmPassword': 'Passwort bestätigen',
  'auth.forgotPassword': 'Passwort vergessen?',
  'auth.noAccount': 'Noch kein Konto?',
  'auth.haveAccount': 'Bereits ein Konto?',
  'auth.orContinueWith': 'oder fortfahren mit',
  'auth.google': 'Google',
  'auth.apple': 'Apple',
  'auth.createAccount': 'Konto erstellen',
  'auth.createAccountTitle': 'Erstelle dein Konto',
  'auth.createAccountSubtitle': 'Beginne heute deine Koreanisch-Lernreise',
  'auth.username': 'Benutzername',
  'auth.usernamePlaceholder': 'Wähle einen Benutzernamen',
  'auth.usernameHint': 'Nur Buchstaben, Zahlen und Unterstriche',
  'auth.passwordHint': 'Mindestens 8 Zeichen mit Groß-, Kleinbuchstaben und Zahl',
  'auth.nativeLanguage': 'Muttersprache',
  'auth.nativeLanguageHint': 'Wir zeigen Erklärungen in dieser Sprache',
  'auth.termsAgree': 'Mit der Anmeldung stimmst du unseren',
  'auth.terms': 'Nutzungsbedingungen',
  'auth.and': 'und',
  'auth.privacyPolicy': 'Datenschutzrichtlinie zu',
  'auth.loginTitle': 'Willkommen zurück',
  'auth.loginSubtitle': 'Melde dich an, um weiterzulernen',
  'auth.loginButton': 'Anmelden',
  'auth.registerButton': 'Registrieren',
  'auth.rememberMe': 'Angemeldet bleiben',

  // ==================== DASHBOARD ====================
  'dashboard.welcome': 'Willkommen zurück',
  'dashboard.todayGoal': 'Heutiges Ziel',
  'dashboard.streak': 'Serie',
  'dashboard.days': 'Tage',
  'dashboard.xp': 'XP',
  'dashboard.level': 'Stufe',
  'dashboard.continueLearning': 'Weiter lernen',
  'dashboard.recommended': 'Für dich empfohlen',
  'dashboard.myCourses': 'Meine Kurse',
  'dashboard.seeAll': 'Alle anzeigen',
  'dashboard.dailyGoalComplete': 'Tagesziel erreicht!',
  'dashboard.keepGoing': 'Weiter so!',
  'dashboard.yourLevel': 'Dein Niveau',
  'dashboard.weeklyProgress': 'Wöchentlicher Fortschritt',

  // ==================== COURSES ====================
  'courses.title': 'Alle Kurse',
  'courses.search': 'Kurse suchen...',
  'courses.all': 'Alle',
  'courses.beginner': 'Anfänger',
  'courses.elementary': 'Grundstufe',
  'courses.intermediate': 'Mittelstufe',
  'courses.advanced': 'Fortgeschritten',
  'courses.lessons': 'Lektionen',
  'courses.enrolled': 'eingeschrieben',
  'courses.progress': 'Fortschritt',
  'courses.completed': 'abgeschlossen',
  'courses.recommended': 'Empfohlen',
  'courses.forYourLevel': 'Für dein Niveau',
  'courses.locked': 'Gesperrt',
  'courses.unlockWith': 'Mit Premium freischalten',

  // ==================== LESSON ====================
  'lesson.loading': 'Lektion wird geladen...',
  'lesson.notFound': 'Lektion nicht gefunden',
  'lesson.quit': 'Bist du sicher, dass du beenden möchtest? Dein Fortschritt geht verloren.',
  'lesson.complete': 'Lektion abgeschlossen!',
  'lesson.perfect': 'Perfekt!',
  'lesson.amazing': 'Erstaunlich! Alles richtig!',
  'lesson.xpEarned': 'XP verdient',
  'lesson.accuracy': 'Genauigkeit',
  'lesson.correct': 'Richtig',
  'lesson.goBack': 'Zurück',
  'lesson.skip': 'Überspringen',
  'lesson.unknownType': 'Unbekannter Übungstyp',

  // ==================== EXERCISES ====================
  'exercise.tapToReveal': 'Tippen, um die Antwort anzuzeigen',
  'exercise.matchPairs': 'Paare zuordnen',
  'exercise.matched': 'zugeordnet',
  'exercise.arrangeWords': 'Wörter anordnen',
  'exercise.speak': 'Sprechen',
  'exercise.listening': 'Höre zu... Sprich jetzt!',
  'exercise.processing': 'Verarbeite deine Sprache...',
  'exercise.tapToSpeak': 'Tippen zum Sprechen',
  'exercise.cantSpeak': 'Kannst du gerade nicht sprechen? Überspringen',
  'exercise.again': 'Nochmal',
  'exercise.gotIt': 'Verstanden!',

  // ==================== PRONUNCIATION ====================
  'pronunciation.title': 'Aussprache-Übung',
  'pronunciation.subtitle': 'Verbessere deine koreanische Aussprache mit KI-Feedback',
  'pronunciation.selectLevel': 'Wähle dein Niveau',
  'pronunciation.beginner': 'Anfänger',
  'pronunciation.intermediate': 'Mittelstufe',
  'pronunciation.advanced': 'Fortgeschritten',
  'pronunciation.score': 'Deine Punktzahl',
  'pronunciation.accuracy': 'Genauigkeit',
  'pronunciation.fluency': 'Flüssigkeit',
  'pronunciation.intonation': 'Intonation',
  'pronunciation.feedback': 'Feedback',
  'pronunciation.tryAgain': 'Erneut versuchen',
  'pronunciation.next': 'Weiter',
  'pronunciation.listen': 'Anhören',
  'pronunciation.slow': 'Langsam',
  'pronunciation.sessionComplete': 'Sitzung abgeschlossen!',
  'pronunciation.bestScore': 'Beste Punktzahl',
  'pronunciation.average': 'Durchschnitt',
  'pronunciation.attempts': 'Versuche',
  'pronunciation.practiceAgain': 'Nochmal üben',
  'pronunciation.changeLevel': 'Niveau ändern',
  'pronunciation.tips': 'Tipps für bessere Aussprache',
  'pronunciation.tip1': 'Höre zuerst das Audio an',
  'pronunciation.tip2': 'Sprich klar und in gleichmäßigem Tempo',
  'pronunciation.tip3': 'Nutze die langsame Wiedergabe für schwierige Wörter',
  'pronunciation.tip4': 'Übe in einer ruhigen Umgebung',

  // ==================== VOCABULARY ====================
  'vocab.title': 'Vokabeln',
  'vocab.totalWords': 'Gesamte Wörter',
  'vocab.mastered': 'Gemeistert',
  'vocab.dueToday': 'Heute fällig',
  'vocab.reviewSession': 'Wiederholungssitzung',
  'vocab.wordsDue': 'Wörter zur Wiederholung',
  'vocab.startReview': 'Wiederholung starten',
  'vocab.allCaughtUp': 'Alles erledigt!',
  'vocab.noWordsDue': 'Keine Wörter zur Wiederholung',
  'vocab.sessionComplete': 'Sitzung abgeschlossen!',
  'vocab.allWords': 'Alle Wörter',

  // ==================== PROFILE ====================
  'profile.title': 'Profil',
  'profile.level': 'Stufe',
  'profile.xpToNext': 'XP bis zur nächsten Stufe',
  'profile.totalXp': 'Gesamt-XP',
  'profile.currentStreak': 'Aktuelle Serie',
  'profile.lessonsDone': 'Abgeschlossene Lektionen',
  'profile.timeLearned': 'Lernzeit',
  'profile.achievements': 'Erfolge',
  'profile.settings': 'Einstellungen',
  'profile.dailyGoals': 'Tägliche Ziele',
  'profile.allAchievements': 'Alle Erfolge',
  'profile.logOut': 'Abmelden',
  'profile.koreanLevel': 'Koreanisch-Niveau',

  // ==================== SETTINGS ====================
  'settings.title': 'Einstellungen',
  'settings.language': 'App-Sprache',
  'settings.preferences': 'Präferenzen',
  'settings.sound': 'Soundeffekte',
  'settings.soundEffects': 'Soundeffekte',
  'settings.soundEffectsDesc': 'Töne bei Übungen abspielen',
  'settings.notifications': 'Benachrichtigungen',
  'settings.notificationsDesc': 'Tägliche Lernerinnerungen erhalten',
  'settings.darkMode': 'Dunkelmodus',
  'settings.darkModeDesc': 'Dunkles Design für angenehmeres Ansehen',
  'settings.dailyReminder': 'Tägliche Erinnerung',
  'settings.account': 'Konto',
  'settings.editProfile': 'Profil bearbeiten',
  'settings.privacy': 'Datenschutz',
  'settings.help': 'Hilfe',
  'settings.about': 'Über',
  'settings.retakeTest': 'Einstufungstest wiederholen',
  'settings.retakeTestDesc': 'Überprüfe dein aktuelles Koreanisch-Niveau',
  'settings.terms': 'Nutzungsbedingungen',

  // ==================== FOOTER ====================
  'footer.privacy': 'Datenschutz',
  'footer.terms': 'Nutzungsbedingungen',
  'footer.contact': 'Kontakt',
  'footer.rights': 'Alle Rechte vorbehalten.',

  // ==================== QUICK ACTIONS ====================
  'quickAction.vocabulary': 'Vokabeln',
  'quickAction.reviewWords': 'Wörter wiederholen',
  'quickAction.allCourses': 'Alle Kurse',
  'quickAction.browseLessons': 'Lektionen durchsuchen',

  // ==================== COURSE DETAIL ====================
  'courseDetail.notFound': 'Kurs nicht gefunden',
  'courseDetail.lessons': 'Lektionen',
  'courseDetail.completed': 'abgeschlossen',

  // ==================== BOTTOM NAVIGATION ====================
  'bottomNav.home': 'Start',
  'bottomNav.courses': 'Kurse',
  'bottomNav.vocab': 'Vokabeln',
  'bottomNav.profile': 'Profil',

  // ==================== AI TUTOR ====================
  'aiTutor.title': 'KI-Tutor',
  'aiTutor.selectScenario': 'Wähle ein Szenario',
  'aiTutor.freeTalk': 'Freies Gespräch',
  'aiTutor.cafe': 'Café-Bestellung',
  'aiTutor.shopping': 'Einkaufen',
  'aiTutor.restaurant': 'Restaurant',
  'aiTutor.friends': 'Freunde finden',
  'aiTutor.interview': 'Vorstellungsgespräch',
  'aiTutor.typeMessage': 'Nachricht eingeben...',
  'aiTutor.send': 'Senden',

  // ==================== ERRORS ====================
  'error.generic': 'Etwas ist schiefgelaufen',
  'error.network': 'Netzwerkfehler. Bitte überprüfe deine Verbindung.',
  'error.notFound': 'Seite nicht gefunden',
  'error.unauthorized': 'Bitte melde dich an, um fortzufahren',
  'error.microphoneAccess': 'Mikrofonzugriff verweigert',
  'error.speechNotSupported': 'Spracherkennung nicht unterstützt. Versuche Chrome.',

  // ==================== COOKIE CONSENT ====================
  'cookie.title': 'Wir verwenden Cookies',
  'cookie.description': 'Wir verwenden Cookies, um Ihre Erfahrung zu verbessern, den Website-Traffic zu analysieren und Inhalte zu personalisieren. Sie können wählen, ob Sie nicht wesentliche Cookies akzeptieren oder ablehnen möchten.',
  'cookie.learnMore': 'Mehr erfahren',
  'cookie.acceptAll': 'Alle akzeptieren',
  'cookie.rejectAll': 'Alle ablehnen',
  // ==================== ADDED (i18n audit 2026-10-24) ====================
  'nav.learn': 'Lernen',
  'nav.culture': 'Kultur',
  'nav.chat': 'Chat',
  'nav.ranking': 'Rangliste',
  'nav.family': 'Familie',
  'nav.premium': 'Premium',
  'home.greeting': 'Hallo',
  'home.streak': 'Tage in Folge',
  'home.dailyGoal': 'Tagesziel',
  'home.myLanguages': 'Meine Sprachen',
  'home.addLanguage': 'Sprache hinzufügen',
  'home.recommended': 'Empfohlen',
  'home.continue': 'Weiterlernen',
  'home.selectLanguage': 'Sprache auswählen',
  'home.totalXp': 'Gesamt-XP',
  'home.bestStreak': 'Beste Serie',
  'home.level': 'Level',
  'chat.aiTutor': 'KI-Tutor',
  'chat.aiTutorDesc': 'Gespräche mit der KI üben',
  'onboarding.welcome.subtitle': 'Lerne jede Sprache mit KI-gestützten Gesprächen',
  'onboarding.selectUILanguage': 'Wähle deine Sprache',
  'onboarding.selectUILanguage.subtitle': 'Diese wird für die App-Oberfläche verwendet',
  'onboarding.selectLearningLanguage': 'Was möchtest du lernen?',
  'onboarding.selectLearningLanguage.subtitle': 'Du kannst mehrere Sprachen lernen',
  'onboarding.selectDailyGoal': 'Lege dein Tagesziel fest',
  'onboarding.selectDailyGoal.subtitle': 'Wie viel Zeit hast du pro Tag?',
  'onboarding.ready': 'Alles bereit!',
  'onboarding.ready.subtitle': 'Starte jetzt deine Sprachlernreise',
  'onboarding.features.languages': '4 Sprachen',
  'onboarding.features.aiTutor': 'KI-Tutor',
  'onboarding.features.dailyGoals': 'Tagesziele',
  'dailyGoal.5min': '5 Minuten',
  'dailyGoal.10min': '10 Minuten',
  'dailyGoal.15min': '15 Minuten',
  'dailyGoal.20min': '20 Minuten',
  'dailyGoal.casual': 'Entspanntes Tempo',
  'dailyGoal.regular': 'Regelmäßiges Üben',
  'dailyGoal.serious': 'Ernsthaftes Lernen',
  'dailyGoal.intense': 'Intensivtraining',
  'learn.title': 'Lernen',
  'learn.currentLevel': 'Aktuelles Level',
  'learn.noCoursesYet': 'Demnächst verfügbar!',
  'learn.noCoursesDescription': 'Kurse für diese Sprache werden vorbereitet.',
  'learn.lessonsCompleted': 'Lektionen abgeschlossen',
  'learn.startCourse': 'Kurs starten',
  'learn.continueCourse': 'Fortsetzen',
  'learn.courseCompleted': 'Abgeschlossen',
  'learn.locked': 'Gesperrt',
  'learn.unlockBy': 'Schließe den vorherigen Kurs ab, um freizuschalten',
  'course.progress': 'Fortschritt',
  'course.lessons': 'Lektionen',
  'course.lessonsCompleted': 'Lektionen abgeschlossen',
  'course.noLessons': 'Lektionen werden vorbereitet...',
  'lesson.tapToReveal': 'Tippen, um die Bedeutung zu sehen',
  'lesson.examples': 'Beispiele',
  'lesson.questionsCorrect': 'richtig',
  'lesson.wordsLearned': 'Wörter',
  'lesson.grammarPoints': 'Grammatik',
  'lesson.backToCourse': 'Zurück zum Kurs',
  'lesson.practiceAgain': 'Erneut üben',
  'lesson.whatYouLearn': 'Das lernst du',
  'lesson.newWords': 'neue Wörter',
  'lesson.exercises': 'Übungen',
  'lesson.startLesson': 'Lektion starten',
  'lesson.reviewLesson': 'Lektion wiederholen',
  'lesson.learnVocabulary': 'Vokabeln lernen',
  'lesson.grammarPoint': 'Grammatikpunkt',
  'lesson.practice': 'Üben',
  'profile.guest': 'Gast',
  'profile.days': 'Tage',
  'profile.longestStreak': 'Längste',
  'profile.lessonsCompleted': 'abgeschlossen',
  'profile.dailyGoal': 'Tagesziel',
  'profile.learningLanguages': 'Lernsprachen',
  'profile.noLanguages': 'Keine Sprachen ausgewählt',
  'profile.minutesPerDay': 'Min./Tag',
  'profile.learningHistory': 'Lernverlauf',
  'profile.viewProgress': 'Deinen Fortschritt ansehen',
  'profile.appSettings': 'App-Einstellungen',
  'profile.languageNotifications': 'Sprache, Benachrichtigungen',
  'profile.loginToSave': 'Melde dich an, um deinen Fortschritt zu speichern',
  'settings.learning': 'Lernen',
  'settings.dailyGoal': 'Tagesziel',
  'settings.minutesPerDay': 'Minuten pro Tag',
  'settings.selectLanguage': 'Sprache auswählen',
  'settings.selectDailyGoal': 'Tagesziel festlegen',
  'settings.perDay': 'pro Tag',
  'settings.appInfo': 'App-Info',
  'settings.logout': 'Abmelden',
};

export default de;
